import * as log from "./log"
export * from "./log"

const gt = globalThis as any
gt.log = log
